import { call, put, takeLatest } from 'redux-saga/effects';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { getCustomerInfo } from '../redux/Actions/OrderservAction';
import SharedUtils from '../utils/SharedUtils';
import { SET_FAVOURITE_ORDER, SET_FAVOURITE_ORDER_SUCCESS, SET_FAVOURITE_ORDER_FAILURE, DELETE_FAVOURITE_ORDER, DELETE_FAVOURITE_ORDER_SUCCESS, DELETE_FAVOURITE_ORDER_FAILURE, GET_ORDER_HISTORY, GET_ORDER_HISTORY_SUCCESS, GET_ORDER_HISTORY_FAILURE, GET_ACTIVE_ORDER_HISTORY, GET_ACTIVE_ORDER_HISTORY_SUCCESS, GET_ACTIVE_ORDER_HISTORY_FAILURE, } from '../constants';
import { setErrorCode } from '../redux/Actions/ErrorAction';
export function* setFavOrderCall(data) {
    try {
        const { payload, postBody, successCallback, errorCallback } = data;
        const { customerId, tenantId, phoneNumber } = payload;
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
            'Content-Type': 'application/json',
        };
        const response = yield call(invokeApi, networkConfig.addFavOrder, { queryProps: { customerId: customerId } }, headers, postBody);
        if (response) {
            yield put({
                type: SET_FAVOURITE_ORDER_SUCCESS,
            });
            successCallback && successCallback(response);
            const customerPayload = {
                customerId: customerId,
                tenantId: tenantId,
                phoneNumber: phoneNumber,
                updateUserData: true
            };
            yield put(getCustomerInfo(customerPayload));
        }
        else {
            yield put({
                type: SET_FAVOURITE_ORDER_FAILURE,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: SET_FAVOURITE_ORDER_FAILURE,
        });
    }
}
export function* setFavOrderSaga() {
    yield takeLatest(SET_FAVOURITE_ORDER, setFavOrderCall);
}
export function* deleteFavOrderCall(request) {
    try {
        const headers = {
            'x-tenant-id': request?.payload?.tenantId,
            'x-is-registered-user': 'true',
            'x-user-id': request?.payload?.customerId,
            'Content-Type': 'application/json',
        };
        const { payload, successCallback, errorCallback } = request;
        const { customerId, tenantId, itemId } = payload;
        const { status } = yield call(invokeApi, networkConfig.deleteFavOrder, {
            queryProps: {
                customerId: customerId,
                itemId: itemId,
            },
        }, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (status === 200) {
            yield put({
                type: DELETE_FAVOURITE_ORDER_SUCCESS,
            });
            successCallback && successCallback();
            const phoneNumber = SharedUtils.getPhoneNumberFromToken();
            const customerPayload = {
                customerId: customerId,
                tenantId: tenantId,
                phoneNumber,
                updateUserData: true
            };
            yield put(getCustomerInfo(customerPayload));
        }
        else {
            yield put({
                type: DELETE_FAVOURITE_ORDER_FAILURE,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: DELETE_FAVOURITE_ORDER_FAILURE,
        });
    }
}
export function* deleteFavOrderCallSaga() {
    yield takeLatest(DELETE_FAVOURITE_ORDER, deleteFavOrderCall);
}
export function* getOrderHistoryCall(data) {
    try {
        const { payload, postBody, successCallback } = data;
        const { customerId, tenantId } = payload;
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
            'Content-Type': 'application/json',
        };
        const { response, status } = yield call(invokeApi, networkConfig.getOrderHistory, { queryProps: { customerId: customerId } }, headers, postBody);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: GET_ORDER_HISTORY_SUCCESS,
                response,
            });
            successCallback && successCallback();
        }
        else {
            yield put({
                type: GET_ORDER_HISTORY_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_ORDER_HISTORY_FAILURE,
        });
    }
}
export function* getOrderHistorySaga() {
    yield takeLatest(GET_ORDER_HISTORY, getOrderHistoryCall);
}
export function* getActiveOrderHistoryCall(data) {
    try {
        const { payload, postBody, successCallback } = data;
        const { customerId, tenantId } = payload;
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
            'Content-Type': 'application/json',
        };
        const { response, status } = yield call(invokeApi, networkConfig.getActiveOrderHistory, { queryProps: { customerId: customerId } }, headers, postBody);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: GET_ACTIVE_ORDER_HISTORY_SUCCESS,
                response,
            });
            successCallback && successCallback();
        }
        else {
            yield put({
                type: GET_ACTIVE_ORDER_HISTORY_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_ACTIVE_ORDER_HISTORY_FAILURE,
        });
    }
}
export function* getActiveOrderHistorySaga() {
    yield takeLatest(GET_ACTIVE_ORDER_HISTORY, getActiveOrderHistoryCall);
}
